/** Shared Cybrbase chart palette — single cobalt hue as an intensity ramp,
 *  with cool neutrals for additional series. No red/amber/green status hues. */
export const CHART_COLORS = [
  "#0058be", // brand cobalt
  "#4D7CFF", // light cobalt
  "#6B8CFF", // lighter cobalt
  "#A9C2FF", // pale cobalt
  "#1A1A2E", // chrome navy
  "#4A5162", // slate
  "#8D93A1", // muted
  "#0EA5E9", // sky cyan (analogous blue)
];

export const chartColor = (index = 0) =>
  CHART_COLORS[index % CHART_COLORS.length];

export const CHART_INK = "#0F1117";
export const CHART_MUTED = "#8D93A1";
export const CHART_SECONDARY = "#4A5162";
export const CHART_GRID = "#E8EEFB";

/** Performance stack — semantic status colors (traffic-light) from the design
 *  system tokens: performed = green, incomplete = amber/yellow, not performed = red.
 *  Applied via inline `style` fill so the CSS custom properties resolve. */
export const STATUS = {
  yes: { top: "var(--cb-chart-success)", base: "var(--cb-chart-success)" }, // green
  incomplete: { top: "var(--cb-chart-warning)", base: "var(--cb-chart-warning)" }, // amber/yellow
  no: { top: "var(--cb-chart-danger)", base: "var(--cb-chart-danger)" }, // red
};

/** Convert #RRGGBB to rgba() with alpha 0–1 */
export function withAlpha(hex, alpha = 1) {
  const raw = String(hex || "").replace("#", "");
  if (raw.length !== 6) return `rgba(26, 79, 222, ${alpha})`;
  const r = parseInt(raw.slice(0, 2), 16);
  const g = parseInt(raw.slice(2, 4), 16);
  const b = parseInt(raw.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function isAllZeroOrEmpty(values) {
  if (!values?.length) return true;
  return values.every((v) => {
    const n = typeof v === "object" && v !== null ? v.y : v;
    return n == null || Number(n) === 0 || Number.isNaN(Number(n));
  });
}

export const EMPTY_CHART_MESSAGE =
  "No assessment data yet — complete domains to populate this chart.";
